import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    freightcalculator,
    FreightcalculatorApiParameter,
    FreightcalculatorResultModel,
} from "@tSurya/Services/FreightService";

type HandlerType = ApiHandler<
    FreightcalculatorApiParameter & HasOnSuccess<FreightcalculatorResultModel> & HasOnError<string>,
    FreightcalculatorResultModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await freightcalculator(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const getFreightResultModel = createHandlerChainRunner(chain, "GetFreightResultModel");
export default getFreightResultModel;
